module.exports = __webpack_public_path__ + "static/media/b1.57e67bd3.jpg";